import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrModalModule } from '../pr-modal/pr-modal.module';
import { PrCityFinderComponent } from './pr-city-finder.component';

@NgModule({
  declarations: [PrCityFinderComponent],
  imports: [CommonModule, FormsModule, PrModalModule],
  exports: [PrCityFinderComponent],
})
export class PrCityFinderModule {}
